/**
 * Утилита для быстрой отладки статуса токенов в консоли
 *
 * Использование:
 * В консоли браузера выполните: window.$debugTokens()
 */

import { consola } from 'consola'

const logger = consola.withTag('token-status')

export const debugTokenStatus = async () => {
  try {
    const { useSessionManager } = await import('~/entities/auth')
    const { useAuthStore } = await import('~/features/auth/model')

    const sessionManager = useSessionManager()
    const authStore = useAuthStore()

    const remainingTime = sessionManager.getTokenRemainingTime()
    const isExpired = sessionManager.isAccessTokenExpired()
    const shouldRefresh = sessionManager.shouldRefreshToken()

    const status = {
      '📊 Статус токенов': {
        hasAccessToken: !!sessionManager.authAccessToken.value,
        hasSessionId: !!sessionManager.authSessionId.value,
        isLoggedIn: authStore.isLoggedIn,
        isExpired,
        shouldRefresh,
      },
      '⏰ Время': {
        remainingSeconds: remainingTime === Infinity ? 'Не установлен' : Math.floor(remainingTime),
        remainingMinutes: remainingTime === Infinity ? 'Не установлен' : (remainingTime / 60).toFixed(2),
        expiresAt: remainingTime === Infinity ? 'Не установлен' : new Date(Date.now() + remainingTime * 1000).toLocaleString(),
      },
      '🔑 Токены': {
        accessTokenLength: sessionManager.authAccessToken.value?.length || 0,
        sessionIdPreview: sessionManager.authSessionId.value?.slice(0, 20) + '...' || 'Нет',
      },
      '📍 Текущий URL': window.location.href,
      '🕐 Timestamp': new Date().toISOString(),
    }

    logger.log(status)
    logger.log('📋 Полный статус:', status)

    return status
  } catch (error) {
    logger.error('❌ Ошибка получения статуса токенов:', error)
    return null
  }
}

// Экспортируем в window для быстрого доступа из консоли
if (process.client) {
  ;(window as any).$debugTokens = debugTokenStatus
  logger.log('💡 Для проверки статуса токенов выполните: window.$debugTokens()')
}


